import { render, staticRenderFns } from "./FreeModeAlertForPresets.vue?vue&type=template&id=725c2e7a&"
import script from "./FreeModeAlertForPresets.vue?vue&type=script&lang=ts&"
export * from "./FreeModeAlertForPresets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports